<template>
    <FormField v-slot="{ inputId, touch }" v-bind="props">
        <PinInputRoot :id="inputId" v-model="coercedModel" class="flex gap-2" :otp type="number" @complete="touch">
            <PinInputInput v-for="(id, index) in 6" :key="id" :index class="w-10 rounded text-center" />
        </PinInputRoot>
    </FormField>
</template>
<script setup lang="ts">
import { PinInputInput, PinInputRoot } from "reka-ui";
import type { FormFieldProps } from "~/utils/types/FormFieldProps";

type FormPinInputProps = FormFieldProps & {
    otp?: boolean;
};

const model = defineModel<number[] | null>();

const { otp = true, ...props } = defineProps<FormPinInputProps>();

// reka-ui PinInputRoot emits string values even with type="number" — the prop
// only restricts keyboard input, it does not coerce model values. This is
// especially visible on paste, where every digit arrives as a string character.
// We coerce here so the valibot schema (which correctly expects number[]) works
// for both typed and pasted input.
const coercedModel = computed({
    get: () => model.value,
    set: (val: (string | number)[] | null) => {
        model.value = val?.map((d) => (typeof d === "string" ? Number(d) : d)) ?? null;
    },
});
</script>
